import { SET_GROUP_PAGINATION } from "../ActionName/ActionName";

const initialState = {
    pagination: { page: 1, limit: 50, total: 0 },
    timestamp: Date.now()
}

const GropPaginationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GROUP_PAGINATION:
            return ({ ...state, pagination: action.value, timestamp: Date.now() })
        default:
            return state;
    }
}
export default GropPaginationReducer;